var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-repeat",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17 2 4 4-4 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11v-1a4 4 0 0 1 4-4h14"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m7 22-4-4 4-4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 13v1a4 4 0 0 1-4 4H3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/repeat.bd1d6a18d2a07341efa2d6f722e5cd7c.svg";
export { ForwardRef as ReactComponent };